import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const StyledGrid = styled(Grid)`
  padding-top: 1px !important;
  display: flex;
  flex-direction: column;
`;

export const StyledFormLabel = styled(FormLabel)`
  margin-bottom: 5px;
`;

export const StyledButtonContainer = styled(Grid)`
  height: 100%;
  display: flex;
  align-items: flex-start;
`;
